export default __webpack_public_path__ + "static/media/early-payment-availed.57189964.png";